/*
  Vocabulary key helpers (window.groomVocabRaw / window.groomLocalePrimary, both rendered by
  snippets/groom-i18n-js.liquid from theme_workspace/groom_vocab.json). coat_types/concerns are
  translatable metafields, so their Liquid .value is Bulgarian on /bg and English on /en; data
  saved before a translation existed (localStorage groom_pet, or the customer's groom.pets
  metafield from the account app) may still hold the Bulgarian word either way. These normalise
  any of those raw forms to the stable key that sections/groom-finder.liquid and
  blocks/groom-pet-fit.liquid already render their "co"/"n"/data-coats/data-needs in, and go the
  other way for building a locale-correct Search & Discovery filter link. Mirrors
  snippets/groom-vocab-key.liquid; unknown input passes through unchanged, same rule.
*/
function groomVocabKey(field, raw) {
  const v = String(raw == null ? '' : raw).trim().toLowerCase();
  if (!v) return '';
  const table = (window.groomVocabRaw && window.groomVocabRaw[field]) || {};
  for (const key in table) {
    const entry = table[key];
    if (entry && (entry.bg === v || entry.en === v)) return key;
  }
  return raw;
}
function groomVocabRawValue(field, key) {
  const entry = window.groomVocabRaw && window.groomVocabRaw[field] && window.groomVocabRaw[field][key];
  if (!entry) return key;
  return window.groomLocalePrimary ? entry.bg : entry.en;
}
function groomVocabLabel(field, key) {
  const T = window.groomT || {};
  return T[`vocab_${field}_${key}`] || key;
}

/* groom.bg: world switch (dog / cat), remembered in localStorage. */
(() => {
  const T = window.groomT || {};
  const t = (k, fb) => T[k] || fb;
  const root = document.documentElement;
  const KEY = 'groom_world';

  function current() {
    return root.getAttribute('data-world') || 'neutral';
  }

  function syncButtons() {
    const world = current();
    // Only buttons take aria-pressed; the home page doors are links, where it is invalid ARIA.
    document.querySelectorAll('button[data-world-set]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.dataset.worldSet === world));
    });
  }

  function setWorld(world) {
    try {
      if (world === 'dog' || world === 'cat') localStorage.setItem(KEY, world);
      else localStorage.removeItem(KEY);
    } catch (e) {}
    root.setAttribute('data-world-pref', world === 'neutral' ? '' : world);
    root.setAttribute('data-world', world);
    syncButtons();
    document.dispatchEvent(new CustomEvent('groom:world', { detail: { world } }));
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-world-set]');
    if (!btn) return;
    event.preventDefault();
    const target = btn.dataset.worldSet;
    // Collections and single-animal products have a dog / cat counterpart (groom-head):
    // go there. On the page's own world, only a tag-filtered collection goes back to unfiltered.
    if (root.hasAttribute('data-world-go-dog') && (target === 'dog' || target === 'cat')) {
      const url = root.getAttribute('data-world-page') === target
        ? root.getAttribute('data-world-go-off')
        : root.getAttribute(`data-world-go-${target}`);
      if (url) {
        setWorld(target);
        window.location.assign(url);
      }
      return;
    }
    // Pressing the active world again returns to the neutral store.
    setWorld(current() === target && target !== 'neutral' ? 'neutral' : target);
    // Doors and cross tiles swap the page below them, so bring the new world's hero into view.
    // On desktop Horizon scrolls .page-wrapper instead of the window, so reset both.
    if (btn.closest('.g-doors, .g-cross')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  window.groomWorld = { set: setWorld, get: current };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncButtons, { once: true });
  else syncButtons();
})();

/*
  "Последно разгледани": product pages push their handle (see groom-head); the row fetches
  compact cards via the Section Rendering API. Card HTML is cached for 10 minutes per tab
  (separately for company buyers, whose prices differ, and per language).
*/
(() => {
  const KEY = 'groom_recent';
  const MAX = 12;
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => typeof h === 'string'); } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} };

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const tag = document.documentElement.hasAttribute('data-b2b') ? 'b2b' : 'r';

  async function card(handle) {
    const ck = `groom_rv_${tag}_${root}${handle}`; // per locale root: /en must not reuse a Bulgarian card
    try {
      const hit = JSON.parse(sessionStorage.getItem(ck) || 'null');
      if (hit && Date.now() - hit.t < 600000) return hit.html;
    } catch (e) {}
    const res = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=groom-rv-card`);
    if (!res.ok) return res.status === 404 ? '' : null;
    const html = (await res.text()).trim();
    try { sessionStorage.setItem(ck, JSON.stringify({ t: Date.now(), html })); } catch (e) {}
    return html;
  }

  async function render(el) {
    const current = el.dataset.current;
    const limit = Number(el.dataset.limit) || 8;
    const handles = read().filter((h) => h !== current).slice(0, limit);
    if (!handles.length) return;
    const results = await Promise.all(handles.map((h) => card(h).catch(() => null)));
    const gone = handles.filter((h, i) => results[i] === '' || (results[i] && !results[i].includes('g-rv__card')));
    if (gone.length) write(read().filter((h) => !gone.includes(h)));
    const html = results.filter((r) => r && r.includes('g-rv__card')).join('');
    if (!html) return;
    el.querySelector('[data-groom-rv-row]').innerHTML = html;
    el.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-groom-rv]').forEach((el) => render(el));
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-groom-rv-clear]');
    if (!btn) return;
    write([]);
    const el = btn.closest('[data-groom-rv]');
    if (el) el.hidden = true;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/*
  "Моят любимец": a pet profile kept on this device (localStorage groom_pet). The header
  chip opens the dialog; product pages show "Подходящо за …" when the product is tagged
  for the pet's species (and names the coat when groom.coat_types matches).
*/
(() => {
  const T = window.groomT || {};
  const t = (k, fb) => T[k] || fb;
  const KEY = 'groom_pet';
  const ACTIVE = 'groom_pet_active';
  const valid = (p) => p && p.name && (p.species === 'dog' || p.species === 'cat');
  const account = window.groomAccount || {};
  const accountPets = Array.isArray(account.pets) ? account.pets.filter(valid) : [];
  const getLocal = () => {
    try {
      const p = JSON.parse(localStorage.getItem(KEY) || 'null');
      return valid(p) ? p : null;
    } catch (e) { return null; }
  };
  // Logged-in customers with saved pets use the account list (active pet remembered per
  // device); everyone else uses the quick profile kept on this device.
  const get = () => {
    if (accountPets.length) {
      let id = null;
      try { id = localStorage.getItem(ACTIVE); } catch (e) {}
      return accountPets.find((p) => p.id === id) || accountPets[0];
    }
    return getLocal();
  };
  const save = (p) => { try { p ? localStorage.setItem(KEY, JSON.stringify(p)) : localStorage.removeItem(KEY); } catch (e) {} };
  window.groomActivePet = get;
  const dialog = () => document.querySelector('[data-groom-pet-dialog]');

  function paint() {
    const p = get();
    document.querySelectorAll('[data-groom-pet-label]').forEach((el) => { el.textContent = p ? p.name : t('pet_default_label', 'Моят любимец'); });
    document.querySelectorAll('[data-groom-tab-pet]').forEach((el) => { el.textContent = p ? p.name : t('pet_tab_default', 'Любимец'); });
    document.querySelectorAll('.g-pet-chip__icon').forEach((el) => { el.textContent = p ? (p.species === 'cat' ? '🐱' : '🐶') : '🐾'; });
    document.querySelectorAll('[data-groom-petfit]').forEach((el) => {
      const species = (el.dataset.species || '').split(',').filter(Boolean);
      if (!p || !species.includes(p.species)) { el.hidden = true; return; }
      // data-coats/data-needs are groom_vocab keys (blocks/groom-pet-fit.liquid); the saved pet's
      // coat/needs may still be the pre-translation Bulgarian word (older localStorage profile, or
      // the account app's groom.pets metafield), so normalise both sides to keys before comparing.
      const coats = (el.dataset.coats || '').split('|').filter(Boolean);
      const needs = (el.dataset.needs || '').split('|').filter(Boolean);
      let text = `${t('pet_fit_prefix', '✓ Подходящо за')} ${p.name}`;
      const petCoatKey = p.coat ? groomVocabKey('coat', p.coat) : '';
      if (petCoatKey && (coats.includes(petCoatKey) || coats.includes('all'))) text += ` · ${String(groomVocabLabel('coat', petCoatKey)).toLocaleLowerCase()} ${t('breed_coat_word', 'козина')}`;
      // needs saved in the account profile ("Моите любимци") that this product is made for
      const petNeedKeys = Array.isArray(p.needs) ? p.needs.map((n) => groomVocabKey('need', n)) : [];
      const NEED_FRIENDLY = { detangling: t('finder_need_detangling', 'лесно разресване'), white_coat: t('finder_need_white_coat', 'бяла или светла козина') };
      const hits = petNeedKeys.filter((nk) => needs.includes(nk)).map((nk) => NEED_FRIENDLY[nk] || groomVocabLabel('need', nk));
      if (hits.length) text += ` · ${hits.join(', ').toLowerCase()}`;
      el.textContent = text;
      el.hidden = false;
    });
  }

  function syncSize(form) {
    const cat = form.querySelector('input[name="species"][value="cat"]').checked;
    const size = form.querySelector('[data-groom-pet-size]');
    if (size) size.hidden = cat;
  }

  function openDialog() {
    const d = dialog();
    if (!d) return;
    const f = d.querySelector('form');
    if (!f) {
      // Logged-in variant: pick the active pet, or offer to move the device profile over.
      const cur = get();
      d.querySelectorAll('[data-groom-pet-active]').forEach((r) => { r.checked = !!cur && r.value === cur.id; });
      const local = getLocal();
      const note = d.querySelector('[data-groom-pet-local]');
      if (note && local) { note.textContent = `${t('pet_local_note_prefix', 'На това устройство е запазен(а)')} ${local.name}. ${t('pet_local_note_suffix', 'Добавете го/я и в профила си.')}`; note.hidden = false; }
      d.showModal();
      return;
    }
    const p = get();
    f.reset();
    if (p) {
      f.elements.petname.value = p.name;
      const sp = f.querySelector(`input[name="species"][value="${p.species}"]`);
      if (sp) sp.checked = true;
      const sz = p.size && f.querySelector(`input[name="size"][value="${p.size}"]`);
      if (sz) sz.checked = true;
      // <select name="coat"> options are keyed (snippets/groom-pet.liquid); normalise an older
      // saved Bulgarian value so it still pre-selects the right option.
      f.elements.coat.value = p.coat ? groomVocabKey('coat', p.coat) : '';
    }
    d.querySelector('[data-groom-pet-forget]').hidden = !p;
    syncSize(f);
    d.showModal();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-groom-pet-open]')) { e.preventDefault(); openDialog(); return; }
    const d = dialog();
    if (!d) return;
    if (e.target.closest('[data-groom-pet-close]') || e.target === d) d.close();
    if (e.target.closest('[data-groom-pet-forget]')) { save(null); paint(); d.close(); }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-groom-pet-active]')) {
      try { localStorage.setItem(ACTIVE, e.target.value); } catch (err) {}
      const p = get();
      if (p && window.groomWorld && !document.documentElement.hasAttribute('data-world-page')) window.groomWorld.set(p.species);
      paint();
      const d = dialog();
      if (d) d.close();
      return;
    }
    const f = e.target.closest('[data-groom-pet-form]');
    if (f && e.target.name === 'species') syncSize(f);
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-groom-pet-form]');
    if (!f) return;
    e.preventDefault();
    const species = (f.querySelector('input[name="species"]:checked') || {}).value;
    const name = f.elements.petname.value.trim();
    if (!name || !species) return;
    const size = species === 'dog' ? (f.querySelector('input[name="size"]:checked') || {}).value || '' : '';
    save({ name, species, size, coat: f.elements.coat.value });
    // The pet's species becomes the shopper's world; pages with their own world keep it.
    if (window.groomWorld && !document.documentElement.hasAttribute('data-world-page')) window.groomWorld.set(species);
    else { try { localStorage.setItem('groom_world', species); } catch (err) {} }
    paint();
    dialog().close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint, { once: true });
  else paint();
})();

/* Long product descriptions fold after the first part (Petmall-style "Още информация"). */
(() => {
  const T = window.groomT || {};
  const t = (k, fb) => T[k] || fb;
  function init() {
    document.querySelectorAll('.g-story').forEach((story) => {
      if (story.dataset.groomFold || story.scrollHeight < 900) return;
      story.dataset.groomFold = '1';
      story.classList.add('is-collapsed');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'g-story__more';
      btn.textContent = t('desc_show_full', 'Покажи цялото описание');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', () => {
        const collapsed = story.classList.toggle('is-collapsed');
        btn.textContent = collapsed ? t('desc_show_full', 'Покажи цялото описание') : t('desc_hide', 'Скрий описанието');
        btn.setAttribute('aria-expanded', String(!collapsed));
        if (collapsed) story.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      story.after(btn);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Phone bottom bar (snippets/groom-tabbar.liquid): open Horizon's own search dialog, menu
   drawer and cart drawer instead of navigating, and mirror the header's cart count. */
(() => {
  function init() {
    const bar = document.querySelector('[data-groom-tabbar]');
    if (!bar) return;
    bar.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-groom-tab]');
      if (!tab) return;
      const kind = tab.dataset.groomTab;
      let el;
      try {
        if (kind === 'search' && (el = document.getElementById('search-modal')) && el.showDialog) { e.preventDefault(); el.showDialog(); }
        else if (kind === 'menu' && (el = (document.querySelector('header-drawer.header-drawer--mobile') || document.querySelector('header-drawer'))?.querySelector('details > summary'))) { e.preventDefault(); el.click(); }
        else if (kind === 'cart' && (el = document.getElementById('cart-drawer')) && el.open) { e.preventDefault(); el.open(); }
      } catch (err) { /* fall back to the link */ window.location.href = tab.href; }
    });
    const badge = bar.querySelector('[data-groom-tab-count]');
    const src = document.querySelector('cart-icon .cart-bubble__text-count');
    if (badge && src) {
      const sync = () => { const n = parseInt(src.textContent, 10) || 0; badge.textContent = n > 99 ? '99+' : String(n); badge.hidden = n === 0; };
      new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true });
      sync();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Shampoo finder (sections/groom-finder.liquid): filters the data island by species, coat
   and need; coat matches rank above "all coat types", products without coat data come last.
   Radio values and the data island's "co"/"n" arrays are groom_vocab keys (language-independent),
   not display text — see groomVocabKey/groomVocabLabel/groomVocabRawValue above. */
(() => {
  const T = window.groomT || {};
  const t = (k, fb) => T[k] || fb;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  function init() {
    const root = document.querySelector('[data-groom-finder]');
    if (!root) return;
    const data = {};
    root.querySelectorAll('[data-finder-data]').forEach((el) => { try { data[el.dataset.finderData] = JSON.parse(el.textContent); } catch (e) { data[el.dataset.finderData] = []; } });
    let urls = {}; try { urls = JSON.parse(root.querySelector('[data-finder-urls]').textContent); } catch (e) {}
    const form = root.querySelector('[data-finder-form]');
    const grid = root.querySelector('[data-finder-grid]');
    const count = root.querySelector('[data-finder-count]');
    const note = root.querySelector('[data-finder-note]');
    const more = root.querySelector('[data-finder-more]');
    const all = root.querySelector('[data-finder-all]');
    const PAGE = 12;
    let shown = PAGE, list = [];

    // start from the shopper's pet profile or world when there is one
    try {
      const pet = (window.groomActivePet && window.groomActivePet()) || JSON.parse(localStorage.getItem('groom_pet') || 'null');
      const w = document.documentElement.dataset.worldPref;
      const sp = (pet && pet.species === 'cat') || (!pet && w === 'cat') ? 'c' : 'd';
      form.querySelector(`input[name=sp][value=${sp}]`).checked = true;
      // pet.coat/pet.needs may still be the pre-translation Bulgarian word (older saved profile);
      // normalise to keys, the radios' values, before looking one up.
      const petCoatKey = pet && pet.coat ? groomVocabKey('coat', pet.coat) : '';
      if (petCoatKey) { const c = form.querySelector(`input[name=coat][value="${CSS.escape(petCoatKey)}"]`); if (c) c.checked = true; }
      const petNeedKeys = pet && Array.isArray(pet.needs) ? pet.needs.map((n) => groomVocabKey('need', n)) : [];
      const needKey = petNeedKeys.find((nk) => form.querySelector(`input[name=need][value="${CSS.escape(nk)}"]`));
      if (needKey) form.querySelector(`input[name=need][value="${CSS.escape(needKey)}"]`).checked = true;
      // links from breed pages: ?sp=d|c&coat=…&need=… (already keys — sections/groom-breed.liquid)
      const qs = new URLSearchParams(location.search);
      ['sp', 'coat', 'need'].forEach((k) => {
        const raw = qs.get(k);
        // old shared links may carry the Bulgarian word (?coat=дълга) instead of the key
        const v = raw && (k === 'coat' ? groomVocabKey('coat', raw) : k === 'need' ? groomVocabKey('need', raw) : raw);
        const el = v && form.querySelector(`input[name=${k}][value="${CSS.escape(v)}"]`);
        if (el) el.checked = true;
      });
    } catch (e) {}

    function val(name) { const el = form.querySelector(`input[name=${name}]:checked`); return el ? el.value : ''; }
    function card(p, coat, need) {
      const tags = [];
      if (coat && p.co && p.co.includes(coat)) tags.push(`<span class="is-hit">✓ ${esc(String(groomVocabLabel('coat', coat)).toLocaleLowerCase())}</span>`);
      else if (p.co && p.co.includes('all')) tags.push(`<span>${esc(t('finder_all_coat_types', 'всички типове козина'))}</span>`);
      if (need && p.n && p.n.includes(need)) tags.push(`<span class="is-hit">✓ ${esc(String(groomVocabLabel('need', need)).toLocaleLowerCase())}</span>`);
      if (p.d) tags.push(`<span>${esc(p.d)}</span>`);
      return `<li><a class="g-fcard" href="${esc(p.u)}"><span class="g-fcard__img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="150" height="150">` : ''}</span><span class="g-fcard__t">${esc(p.t)}</span><span class="g-fcard__tags">${tags.join('')}</span><span class="g-fcard__p">${esc(p.p)}</span></a></li>`;
    }
    function run() {
      const sp = val('sp'), coat = val('coat'), need = val('need'), kind = val('kind') || 's';
      const pool = (data[kind] || []).filter((p) => p.s.includes(sp));
      const score = (p) => (coat ? (p.co && p.co.includes(coat) ? 2 : p.co && p.co.includes('all') ? 1 : p.co ? -1 : 0) : 0);
      let res = pool.filter((p) => score(p) >= 0);
      let relaxed = false;
      if (need) {
        const withNeed = res.filter((p) => p.n && p.n.includes(need));
        if (withNeed.length) res = withNeed;
        else { relaxed = true; }
      }
      res.sort((a, b) => score(b) - score(a) || (b.n && need && b.n.includes(need) ? 1 : 0) - (a.n && need && a.n.includes(need) ? 1 : 0) || b.pro - a.pro || a.v - b.v);
      list = res; shown = PAGE;
      const noun = kind === 's'
        ? (res.length === 1 ? t('finder_noun_shampoo_one', 'шампоан') : t('finder_noun_shampoo_other', 'шампоана'))
        : (res.length === 1 ? t('finder_noun_conditioner_one', 'балсам') : t('finder_noun_conditioner_other', 'балсама'));
      count.textContent = res.length ? `${res.length} ${t('finder_suitable', 'подходящи')} ${noun}` : t('finder_no_exact_match', 'Няма точно съвпадение');
      note.hidden = !relaxed;
      if (relaxed) note.textContent = t('finder_relaxed_note', 'Нямаме продукт, обявен точно за тази нужда при тази козина – показваме подходящите за козината. Пишете ни във Viber за съвет.');
      if (!res.length) note.hidden = false, note.textContent = `${t('finder_try_prefix', 'Опитайте')} „${t('finder_not_sure', 'Не знам')}“ ${t('finder_no_results_note_suffix', 'за козината или ни пишете във Viber – ще помогнем.')}`;
      const base = (urls[kind] || {})[sp] || all.getAttribute('href');
      const q = new URLSearchParams();
      // Search & Discovery's filter.p.m.* compares against the metafield's *translated* value, so
      // this must send the raw word in whichever language the current page is in (bg on /bg, en on
      // /en) — not the key used everywhere else on this page.
      if (coat) q.set('filter.p.m.groom.coat_types', groomVocabRawValue('coat', coat));
      if (need) q.set('filter.p.m.groom.concerns', groomVocabRawValue('need', need));
      all.href = base + (q.toString() ? `?${q}` : '');
      paint(coat, need);
    }
    function paint(coat, need) {
      grid.innerHTML = list.slice(0, shown).map((p) => card(p, coat, need)).join('');
      more.hidden = list.length <= shown;
    }
    form.addEventListener('change', run);
    more.addEventListener('click', () => { shown += PAGE; paint(val('coat'), val('need')); });
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Home rows for the dog/cat worlds ship as empty <div data-world-fetch> placeholders
   (sections/product-list.liquid). When the page is in that world (now, after a switch, or as soon as a
   switch button is pressed) fetch the real sections through the Section Rendering API and swap them in. */
(() => {
  const html = document.documentElement;
  const pending = {};
  function load(w) {
    if (pending[w]) return pending[w];
    const slots = [...document.querySelectorAll(`[data-world-fetch="${w}"]`)];
    if (!slots.length) return Promise.resolve();
    const ids = slots.map((s) => s.dataset.sectionId);
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    pending[w] = fetch(`${root}?sections=${ids.join(',')}`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((json) => {
        slots.forEach((slot) => {
          const id = slot.dataset.sectionId;
          const wrap = document.getElementById(`shopify-section-${id}`);
          if (!json[id] || !wrap || !slot.isConnected) return;
          // createContextualFragment (unlike innerHTML) lets any <script> in the section run, as the old
          // <template> clone did.
          const frag = document.createRange().createContextualFragment(json[id]);
          const fresh = frag.querySelector(`#shopify-section-${id}`);
          if (fresh) wrap.replaceChildren(...fresh.childNodes);
        });
      })
      .catch(() => {
        delete pending[w]; // the placeholder stays; the next switch into this world retries
      });
    return pending[w];
  }
  function wake() {
    const w = html.getAttribute('data-world');
    if (w === 'dog' || w === 'cat') load(w);
  }
  wake();
  new MutationObserver(wake).observe(html, { attributes: true, attributeFilter: ['data-world'] });
  // Start the request on press rather than after the click's world change.
  document.addEventListener('pointerdown', (e) => {
    const b = e.target instanceof Element && e.target.closest('[data-world-set]');
    if (b && (b.dataset.worldSet === 'dog' || b.dataset.worldSet === 'cat')) load(b.dataset.worldSet);
  }, { passive: true });
})();

/* Size/variant change: Horizon doesn't re-render the product section; each block pulls its own new HTML.
   Our variant-dependent blocks (SKU + stock, ready-solution cost, "Използвай с") sit in
   <div data-groom-sync="block-id"> and are swapped from the new HTML here. */
(() => {
  function onSelect(e) {
    if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
    const scope = e.target.closest('.shopify-section, dialog') || document;
    (e.promise || Promise.resolve({})).then(({ detail } = {}) => {
      const html = detail && detail.html;
      if (!html) return;
      scope.querySelectorAll('[data-groom-sync]').forEach((el) => {
        const fresh = html.querySelector(`[data-groom-sync="${CSS.escape(el.dataset.groomSync)}"]`);
        if (fresh) el.replaceWith(document.importNode(fresh, true));
      });
    }).catch(() => {});
  }
  // StandardEvents.productSelect from https://cdn.shopify.com/storefront/standard-events.js
  document.addEventListener('shopify:product:select', onSelect, true);
})();

/* Category bar: mark it scrollable (edge fade) when the links don't fit. */
(() => {
  function upd() {
    document.querySelectorAll('.g-dept').forEach((n) => {
      const scroll = n.scrollWidth > n.clientWidth + 2;
      n.classList.toggle('is-scroll', scroll);
      n.classList.toggle('is-end', scroll && n.scrollLeft + n.clientWidth >= n.scrollWidth - 4);
    });
  }
  let t;
  window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(upd, 100); });
  document.addEventListener('scroll', (e) => { if (e.target instanceof Element && e.target.classList.contains('g-dept')) upd(); }, true);
  new MutationObserver(upd).observe(document.documentElement, { attributes: true, attributeFilter: ['data-world'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upd, { once: true });
  else upd();
})();

/* Announcement bar safety net: if no slide starts visible, show the first one rendered. */
(() => {
  document.querySelectorAll('announcement-bar-component').forEach((bar) => {
    const slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length && ![...slides].some((s) => s.getAttribute('aria-hidden') === 'false')) slides[0].setAttribute('aria-hidden', 'false');
  });
})();
